// extracted by mini-css-extract-plugin
export var phone = "_2i-0";
export var phoneDragging = "_2i-1";